import React, { useEffect, useState } from "react";
import StatusBadgeClientInvite from "../StatusBadge/StatusBadgeClientInvite";
import DetailsPanel from "./DetailsPanel";
import classNames from "classnames";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import styles from "./DetailsPanel.module.scss";
import { useAlert } from "../../contexts/AlertContext";
import {
  resendInvite,
  updateInviteeStatus,
} from "../../services/inviteService";
import AlertCustom from "../../components/AlertCustom/AlertCustom";
import ImagePreviewLightbox from "../ImagePreviewLightbox";
import PhoneInput, {
  formatPhoneNumber,
  formatPhoneNumberIntl,
  parsePhoneNumber,
} from "react-phone-number-input";
import { parsePhoneNumberFromString } from "libphonenumber-js";

const getAddress = (userInfo) => {
  const addressArr = [];
  if (userInfo?.invited_user?.address) {
    addressArr.push(userInfo?.invited_user?.address);
  }
  if (userInfo?.invited_user?.city) {
    addressArr.push(userInfo?.invited_user?.city);
  }
  if (userInfo?.invited_user?.state?.name) {
    addressArr.push(userInfo?.invited_user?.state?.name);
  }
  if (userInfo?.invited_user?.country?.code) {
    addressArr.push(userInfo?.invited_user?.country?.code);
  }
  if (userInfo?.invited_user?.zipCode) {
    addressArr.push(userInfo?.invited_user?.zipCode);
  }
  return addressArr.join(", ");
};

const getPhone = (userInfo) => {
  let phoneNo = userInfo?.invited_user?.phoneNo || "";
  const countryCode = userInfo?.invited_user?.countryCode || "";
  
  if (phoneNo.startsWith("0")) {
    phoneNo = phoneNo.slice(1);
  }

  const phoneString = `+${countryCode}${phoneNo}`;
  const parsed = parsePhoneNumberFromString(phoneString);

  if (!parsed) return "";

  // 📞 Example output: +91 91234 56789 or +1 (201) 555-0123
  return `+${parsed.countryCallingCode} ${parsed.formatNational().startsWith("0")
    ? parsed.formatNational().slice(1)
    : parsed.formatNational()
    }`;
};

const ClientAccessDetailsPanel = ({
  onClose,
  item,
  auth,
  updateInviteeListData,
  updateInviteeStatusHandle,
}) => {
  const [selectedInviteeData, setSelectedInviteeData] = useState();
  const address = getAddress(item);
  const phone = getPhone(item);
  const { showAlert } = useAlert();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setSelectedInviteeData(item);
  }, [item]);

  const resendInviteHandle = async (userId) => {
    // setNotification(null);
    setLoading(true);
    try {
      const res = await resendInvite({ id: userId });
      console.log("Resend Invite successful:", res);
      showAlert({
        title: "Contact Access Notification",
        message: res?.message ?? "something went wrong",
        variant: "success",
      });
      // setNotification(
      //   <AlertCustom
      //     message={res?.message ?? "something went wrong"}
      //     variant="success"
      //   />
      // );
    } catch (error) {
      showAlert({
        title: "Contact Access Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
      // setNotification(
      //   <AlertCustom
      //     message={error?.response?.data?.message ?? "something went wrong"}
      //     variant="danger"
      //   />
      // );
      // console.error("Resend Invite failed:", error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   setNotification(null);
  // }, [item]);
  return (
    <DetailsPanel isOpen={!!item}>
      <div
        className={classNames(
          styles["detail-panel-head"],
          "d-flex align-items-center justify-content-between gap-3"
        )}
      >
        <h2 className="h5 fw-semibold mb-0">Details</h2>
        <button type="button" className="btn-reset" onClick={onClose}>
          <Image src="/images/btn-close-square.svg" />
        </button>
      </div>
      <div className={styles["detail-panel-body"]}>
        <div className="d-flex align-items-center gap-3 mb-3">
          {item?.invited_user?.profilePic ? (
            <ImagePreviewLightbox
              className="user-avtar user-avtar-48"
              src={item.invited_user.profilePic}
            >
              <Image
                src={item?.invited_user?.profilePic}
                className="object-fit-cover rounded-circle"
                width={48}
                height={48}
                alt="User Avatar"
              />
            </ImagePreviewLightbox>
          ) : item?.invited_user ? (
            <Image
              width={32}
              height={32}
              alt="User Avatar"
              className="object-fit-cover rounded-circle"
              src={`https://ui-avatars.com/api/?name=${item.invited_user.firstName}+${item.invited_user.lastName}&background=007bff&color=fff&size=100`}
            />
          ) : (
            <div className="user-avtar user-avtar-32 bg-blue-600"><span className="fs-15">N/A</span></div>
          )}

          <h3 className="h6 mb-0 fw-semibold d-flex align-items-center gap-2">
            {selectedInviteeData?.invited_user?.firstName}{" "}
            {selectedInviteeData?.invited_user?.lastName}{" "}
            {!selectedInviteeData?.status ? (
              <StatusBadgeClientInvite status="Blocked" />
            ) : (
              <StatusBadgeClientInvite
                status={selectedInviteeData?.invited_user ? "Completed" : "Pending"}
              />
            )}
          </h3>
        </div>
        <div className="border-top pt-3 mt-3">
          <h4 className="text-blue fs-7 fw-medium mb-3">Personal Details</h4>

          <ul className="list-unstyled">
            <li className="fs-6 mb-3">
              <span className="fs-7 text-gray-500 d-block">Email Address</span>
              {item?.email}
            </li>

            {item?.invited_user?.phoneNo && (
              <li className="fs-6 mb-3">
                <span className="fs-7 text-gray-500 d-block">Phone</span>
                {phone}
              </li>
            )}
          </ul>
        </div>

        {item?.invited_user?.companyName && (
          <div className="border-top pt-3 mt-3">
            <h4 className="text-blue fs-7 fw-medium mb-3">Company Details</h4>

            <ul className="list-unstyled">
              {item?.invited_user?.companyName && (
                <li className="fs-6 mb-3">
                  <span className="fs-7 text-gray-500 d-block">Company Name</span>
                  {item?.invited_user?.companyName}
                </li>
              )}
              {address && (
                <li className="fs-6 mb-3">
                  <span className="fs-7 text-gray-500 d-block">Address</span>
                  {address}
                </li>
              )}
            </ul>
          </div>
        )}

        <div className="border-top pt-3 mt-3">
          <h4 className="text-blue fs-7 fw-medium mb-3">Other Details</h4>

          <ul className="list-unstyled">
            <li className="fs-6 mb-3">
              <span className="fs-7 text-gray-500 mb-2 d-block">
                Invited By
              </span>
              <div className="d-flex align-items-center gap-2">
                {item?.inviter?.profilePic ? (
                  <ImagePreviewLightbox className="user-avtar user-avtar-32" src={item?.inviter?.profilePic || "/images/user-avatar-1.png"}>
                    <Image
                      width="32"
                      height="32"
                      alt="User Avatar"
                      className="object-fit-cover rounded-circle"
                      src={item?.inviter?.profilePic}
                    />
                  </ImagePreviewLightbox>
                ) : (
                  <Image
                    width={32}
                    height={32}
                    alt="User Avatar"
                    className="object-fit-cover rounded-circle"
                    src={`https://ui-avatars.com/api/?name=${item?.inviter?.firstName}+${item?.inviter?.lastName}&background=007bff&color=fff&size=100`}
                  />
                )}
                <span className="text-gray-700">
                  {item?.inviter?.roleId === 2
                    ? item?.inviter?.companyName
                    : `${item?.inviter?.firstName || ''} ${item?.inviter?.lastName || ''}`.trim()
                  }
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div className={styles["detail-panel-footer"]}>
        {/* <div className={styles["notification-location"]}>{notification}</div> */}
        <div className="d-flex align-align-items-center gap-2">
          {!item?.invited_user &&
            <Button
              className="btn-md shadow-none d-flex align-items-center gap-2"
              onClick={() => resendInviteHandle(item.id)}
              disabled={loading}
              variant="primary"
            >
              <Image
                src="/images/paper-plane-white.svg"
                width={20}
                height={20}
                alt="Paper Plane Tilt Icon"
              />{" "}
              Resend Invite
            </Button>
          }
          {auth.user.roleId != 3 && <Button
            variant={selectedInviteeData?.status ? "outline-danger" : "success"}
            onClick={() => setShowModal(true)}
            className="btn-md shadow-none d-flex align-items-center gap-2"
          >
            <Image
              src={
                selectedInviteeData?.status
                  ? "/images/prohibit-red.svg"
                  : "/images/check-circle-white.svg"
              }
              width={20}
              height={20}
              alt={
                selectedInviteeData?.status
                  ? "Prohibit Icon"
                  : "Check Circle Icon"
              }
            />{" "}
            {selectedInviteeData?.status ? "Block" : "Unblock"} User
          </Button>}

        </div>
      </div>

      <Modal
        className="info-modal"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="text-center">
            <Image
              src={
                selectedInviteeData?.status
                  ? "/images/prohibited-badge-red.svg"
                  : "/images/check-badge-green.svg"
              }
              alt="Prohibited Icon Badge"
            />
            <h2 className="fs-2 fw-semibold text-gray-700 mt-5 mb-2">
              Are you sure you want to{" "}
              {selectedInviteeData?.status ? "block" : "unblock"} this user?
            </h2>

            <div className="d-flex align-items-center gap-3">
              <Button
                onClick={async () => {
                  setLoading(true);
                  const success = await updateInviteeStatusHandle(selectedInviteeData);
                  if (success) {
                    setSelectedInviteeData({
                      ...selectedInviteeData,
                      status: !selectedInviteeData?.status,
                    });
                  }
                  setShowModal(false);
                  setLoading(false);
                }}
                variant="primary"
                className="btn w-100 mt-5"
                disabled={loading}
              >
                Yes, {selectedInviteeData?.status ? "Block User" : "Sure!"}
              </Button>
              <Button
                variant="gray"
                className="btn w-100 mt-5"
                onClick={() => setShowModal(false)}
              >
                {selectedInviteeData?.status ? "No, Not Yet!" : "Nope, Cancel"}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </DetailsPanel>
  );
};

export default ClientAccessDetailsPanel;
